/**
 * Get the CSS style object of item in the square grid container from it's index.
 * @param {number} columnCount
 * @param {number} columnGap
 * @param {number} itemIndex
 * @param {number} itemSize
 * @param {number} rowGap
 * @returns {object}
 */
const getItemStyle = (columnCount, columnGap, itemIndex, itemSize, rowGap) => {
  const rowIndex = itemIndex % columnCount;
  const columnIndex = (itemIndex - rowIndex) / columnCount;
  return {
    height: itemSize,
    left: rowIndex * (itemSize + columnGap),
    top: columnIndex * (itemSize + rowGap),
    width: itemSize,
  };
};

export default getItemStyle;
